"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import SinteredLayersDiagram from "@/components/diagrams/SinteredLayersDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function LayerStandardSinteredMeshPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = {
    en: {
      sectionTitle: "Standard 5-Layer Sintered Wire Mesh Architecture",
      sectionLead: "Structural cross-section showing protective layer, control layer, dispersion buffer, and dual reinforcing skeleton layers united by solid-state vacuum diffusion.",
      cardTitle: "5-Layer Structural Cross-Section",
      cardDesc: "L01 Protective Layer, L02 Control Layer, L03 Dispersion Layer, L04 Reinforcing Support 1, and L05 Base Skeleton 2 with directional process flow."
    },
    zh: {
      sectionTitle: "5 层标准烧结复合网层析立体结构",
      sectionLead: "典型截面展示保护层、精度控制层、分流缓冲层及双层加强支撑骨架在真空高温下的原子级熔合结合形态。",
      cardTitle: "5 层复合截面与介质流向示意",
      cardDesc: "L01 表面保护层至 L05 骨架支撑层各司其职，在工作负荷与反洗脉冲下保持恒定截留精度与刚性自支撑。"
    },
    es: {
      sectionTitle: "Arquitectura de malla sinterizada estándar de 5 capas",
      sectionLead: "Corte transversal que ilustra capa protectora, capa de control, capa de dispersión y dos capas de refuerzo estructural unidas por difusión térmica.",
      cardTitle: "Esquema en corte de 5 capas",
      cardDesc: "L01 Capa protectora, L02 Capa de control, L03 Capa de dispersión, L04 Soporte 1 y L05 Esqueleto base 2 con flujo direccional."
    },
    de: {
      sectionTitle: "Architektur des 5-lagigen Standard-Sintergewebes",
      sectionLead: "Struktureller Querschnitt mit Schutzlage, Kontrollschicht, Dispersionslage und zwei Stützschichten, diffusionsgebunden im Vakuum.",
      cardTitle: "5-Lagen-Strukturquerschnitt",
      cardDesc: "L01 Schutzlage, L02 Kontrollschicht, L03 Verteilungslage, L04 Stützlage 1 und L05 Skelettlage 2 mit Richtungsströmung."
    },
    fr: {
      sectionTitle: "Architecture de la toile frittée standard 5 couches",
      sectionLead: "Coupe transversale illustrant la couche protectrice, la couche de contrôle, la dispersion et la double armature unies par diffusion sous vide.",
      cardTitle: "Schéma structurel 5 couches",
      cardDesc: "L01 Protection, L02 Contrôle, L03 Dispersion, L04 Renfort 1 et L05 Ossature 2 sous flux régulier."
    },
    pt: {
      sectionTitle: "Arquitetura da malha sinterizada padrão de 5 camadas",
      sectionLead: "Corte estrutural ilustrando camada protetora, controle, dispersão e dois reforços de sustentação unidos por difusão atômica.",
      cardTitle: "Esquema em corte de 5 camadas",
      cardDesc: "L01 Camada protetora, L02 Controle, L03 Dispersão, L04 Suporte 1 e L05 Esqueleto 2 sob fluxo contínuo de processo."
    }
  };
  const d = pick(lang, diagramCopy);
  const diagram = <DiagramSection id="five-layer-diagram" title={d.sectionTitle} lead={d.sectionLead} tone="background">
      <div className="max-w-3xl mx-auto">
        <DiagramCard index="SWM-5L" badge="5-Layer Standard" title={d.cardTitle} description={d.cardDesc}>
          <SinteredLayersDiagram variant="five" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}